<template>
  <div class="loading-screen">
    <v-layout column align-center>
      <v-flex xs4 class="ponce-logo">
        <div :class="!this.logoLoaded ? 'logo-bg' : 'logo-bg bg-spinner'" />
        <div class="logo-container">
          <v-img :src="require('../../assets/logoPonce.png')" class="logo" width="100%" contain @load="onLogoLoad"></v-img>
        </div>
        <div class="bg-overlay" />
      </v-flex>
      <v-flex xs4 class="ponce-title">
        <h3>PONCE</h3>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import getUserData from '@/lib/getUserData'
import getLanguage from '@/lib/get-language'
import {WEBHOOKS_PATHS} from '../../constants/const'
import { firestore } from '@/plugins/firebase'
import {
  resolveFieldSurveyClassification,
  getLoadingScreenFieldSurveyId
} from '@/lib/fieldSurveysRouting'

export default {
  data () {
    return {
      logoLoaded: false
    }
  },
  async mounted () {
    if (this.$route.query.to && this.$route.query.to.includes('/r/')) {
      await this.validateShortLinkRedirection(this.$route.query.to)
    }

    const userAuth = this.$store.getters.userAuth
    const userId = this.$store.getters.impersonatedUserId || (userAuth && userAuth.user && userAuth.user.uid)
    if (userId) {
      const result = await getUserData(userId)
      if (!result.error) {
        const lastCampaignSettings = this.$store.getters.availableCampaigns.length ? this.$store.getters.user.userCampaignsSettings.find(campaign => campaign.id === this.$store.getters.availableCampaigns[0].id) : this.$store.getters.user.userCampaignsSettings[0]

        const hasFieldSurveyAccess = !!(this.$store.getters.user.fieldSurveyIds && this.$store.getters.user.fieldSurveyIds.length)
        if (!lastCampaignSettings && !this.$store.getters.user.audits && !hasFieldSurveyAccess) {
          this.$store.commit('setUserAuth', null)
          this.$store.commit('setImpersonatedUserId', null)
          this.$store.commit('setAppReady', false)
          this.$i18n.locale = getLanguage()
          this.$router.push({name: 'Signin'})
          return
        }
        this.$store.commit('setAppReady', true)

        let routeToPush = this.$route.query.to || null
        if (!routeToPush && !this.$store.getters.impersonatedUserId) {
          const fieldSurveyIds = this.$store.getters.user.fieldSurveyIds || []
          if (fieldSurveyIds.length) {
            const db = await firestore
            const classification = await resolveFieldSurveyClassification(db, fieldSurveyIds)
            const redirectFieldSurveyId = getLoadingScreenFieldSurveyId(classification)
            if (redirectFieldSurveyId) {
              delete this.$route.query.to
              this.$router.push({ path: `/fieldSurveys/${redirectFieldSurveyId}`, query: this.$route.query })
              return
            }
          }
        }
        if (!routeToPush) {
          routeToPush = !lastCampaignSettings && (this.$store.getters.user.audits || hasFieldSurveyAccess) ? 'audits' : lastCampaignSettings.editDataPermission ? 'organizationHome' : 'reports'
        }
        delete this.$route.query.to
        this.$router.push({ path: routeToPush, query: this.$route.query })
        return
      }
      if (result.errorMessage) {
        this.$root.snack.show({text: result.errorMessage, error: true})
      }
    }

    this.$i18n.locale = getLanguage()

    const routeToPush = this.$route.query.to ? this.$route.query.to : 'signin'
    delete this.$route.query.to
    this.$router.push({path: routeToPush, query: this.$route.query})
  },
  methods: {
    onLogoLoad () {
      this.logoLoaded = true
    },
    async validateShortLinkRedirection (toPath) {
      try {
        const shortId = toPath.split('/r/')[1]

        const webhookUrl = `${process.env.WEBHOOKS_URL}${WEBHOOKS_PATHS.LINK_SHORTENER}`
        const params = new URLSearchParams({shortId})

        const response = await fetch(`${webhookUrl}?${params}`, {
          method: 'GET',
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
            'authorization': process.env.WEBHOOKS_BASIC_TOKEN
          }
        })

        if (!response.ok || response.status !== 200) {
          // If there is an error or short link is not found, redirect to the home view
          this.$router.replace({ path: '/loading', query: { to: 'organizationHome' } })
        } else {
          // If the short link is found, redirect to the new path
          const data = await response.json()
          this.$router.replace({ path: '/loading', query: { to: data.path } })
        }
      } catch (error) {
        console.log('error:', error)
        this.$router.replace({ path: '/loading', query: { to: 'organizationHome' } })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// LoadingScreen.vue?0ea44815